import { Injectable } from "@angular/core";
import { environment } from '@env/environment';
import { HttpClient } from "@angular/common/http";

@Injectable()
export class PostItService {
    private ngt18Url: string = environment.API_URL+'main/';
    public previosSearchParams;

    constructor(private http: HttpClient) { }

    getNotes(data) {
        return this.http.post(this.ngt18Url + 'module.das.postitList', data);
    }

    createNote(data) {
        return this.http.post(this.ngt18Url + 'module.das.postitCreate', data);
    }
    
    editNote(data) {
        return this.http.post(this.ngt18Url + 'module.das.postitEdit', data);
    }

    deleteNote(data) {
        return this.http.post(this.ngt18Url + 'module.das.postitDelete', data);
    }
}   